import styled from "styled-components";

export const Title = styled.div`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 800;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 20px;
`;
export const Wrapper = styled.div`
  background: rgba(245, 248, 251, 1);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 106px;

  @media (max-width: 1000px) {
    flex-direction: column;
    gap: 40px;
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImgWrp = styled.div`
  width: 192px;
  height: 192px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  position: relative;

  @media (max-width: 1000px) {
    margin: 0 auto;
  }
`;
export const BtnDownload = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  opacity: 0;
  z-index: 1000;
  cursor: pointer;
`;

export const ButtomLabel = styled.div`
  z-index: 100;
  position: absolute;
  bottom: 14px;
  font-family: Manrope;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  padding: 6px 12px;
  border: 1px solid rgba(1, 18, 36, 0.08);
  border-radius: 8px;
  cursor: pointer;
`;

export const ImgContent = styled.img`
  width: 192px;
  height: 192px;
  object-fit: cover;
  border-radius: 8px;
`;

export const ExitBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 20px;
  z-index: 100;
`;
